/* eslint-disable no-mixed-spaces-and-tabs */
import { Card, CircularProgress } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ClientConfigTable from '@/components/tables/ClientConfigTable';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { paths } from '@/app/routes';

export const ConfigTableView = () => {
	const navigate = useNavigate();

	const { getFeatureFlags, isLoading } = useFeatureFlagContext();
	const viewConfigTable = Boolean(getFeatureFlags('viewConfigTable')?.active);

	useEffect(() => {
		if (!isLoading && !viewConfigTable) {
			navigate(`${paths.settings}/user`);
		}
	}, [isLoading, viewConfigTable, navigate]);

	return (
		<Card>
			{isLoading ? <CircularProgress /> : viewConfigTable ? <ClientConfigTable /> : <></>}
		</Card>
	);
};
